module.exports = __webpack_public_path__ + "img/founder.59ba655d.jpg";